import React, { useContext } from "react";

// import { useTheme } from "@mui/material/styles";
import { ColorModeContext } from "../context/ColorModeProvider";
import IconButton from "@mui/material/IconButton";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
// import { useTheme } from "@emotion/react";
// import useMediaQuery from "@mui/material/useMediaQuery";

export default function ThemeSwitcher() {
  const { theme, colorMode } = useContext(ColorModeContext);

  return (
    <IconButton
      sx={{ ml: 1 }}
      onClick={colorMode.toggleColorMode}
      color="inherit"
    >
      {theme.palette.mode === "dark" ? (
        <LightModeIcon
          sx={{
            color: "#ffffff",
          }}
        />
      ) : (
        <DarkModeIcon
          sx={{
            color: "rgba(101,147,181,.9)",
          }}
        />
      )}
    </IconButton>
  );
}
